/**
 * Keywords that auto-trigger plan mode when present in a user message. Kept here
 * so the matcher is shared and easy to tune from analytics
 * (`coco_plan_mode_toggled`).
 */
export const PLAN_MODE_KEYWORDS = [
  'plan',
  'build',
  'workflow',
  'agent',
  'subagent',
  'trigger',
  'automation',
] as const;

// Leading word boundary only (no trailing) so plurals and gerunds match:
// "workflows", "agents", "building", "planning", "triggers", "automations".
const PLAN_MODE_KEYWORD_REGEX = new RegExp(
  `\\b(${PLAN_MODE_KEYWORDS.join('|')})`,
  'i'
);

/** True when the text contains a planning keyword (case-insensitive). */
export function messageTriggersPlanMode(text: string): boolean {
  return PLAN_MODE_KEYWORD_REGEX.test(text);
}
